module.exports = __webpack_public_path__ + "img/close.aeb1ae8a.svg";